import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=2845fffe&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=2845fffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2845fffe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2845fffe')) {
      api.createRecord('2845fffe', component.options)
    } else {
      api.reload('2845fffe', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=2845fffe&scoped=true&", function () {
      api.rerender('2845fffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HKG2OPqc1T14/JS/comp/DateRangeExt.vue"
export default component.exports